var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var COMMON_STYLES = {
    transition: '300ms opacity',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
};
export var CLOSED = {
    general: __assign({ display: 'block', border: 'none', opacity: 0, visibility: 'hidden', position: 'fixed', zIndex: '-1 !important', width: '100%', height: '100%', top: '-1000px !important' }, COMMON_STYLES),
};
export var OPEN = __assign({ borderRadius: 0, border: 'none', height: '100%', opacity: 1, overflow: 'hidden', position: 'fixed', visibility: 'visible', width: '100% !important', zIndex: 2147483600 }, COMMON_STYLES);
export var CLOSE_BUTTON = {
    position: 'absolute',
    top: '1rem',
    right: '1rem',
};
export var LAUNCHER = {
    position: 'fixed',
    opacity: 0,
    bottom: 10,
    right: 10,
    border: 'none',
    // Less than the widget itself
    zIndex: 2147483400,
    // Width is overrode at the first render of the inner components
    width: '100vw',
};
